import React, { useState, useEffect, useCallback } from "react";
import styles from "./Rally.module.css";
import ProgressBar from "../components/ProgressBar";
import NBLogo from "../components/NBLogo";
import NavPanel from "../components/NavPanel";
import TapArea from "../components/TapArea";

import { useNavigate } from "react-router-dom";

const products = [
  { name: "Product 1", img_main: 'rally/1_main.png', image: "rally/1_thumb.png", desc: 'White with Navy', link: '',
    dots: [ 
      {x: 125, y: 180, image: 'rally/1_2.png', feature: 'Incredible Comfort', details: 'Fresh Foam X midsole delivers our most cushioned Fresh Foam experience.'}, 
      {x: 135, y: 70, image: 'rally/1_1.png', feature: 'Intelligently crafted', details: 'Inspired by professional rally cars, this feature-driven style is built for hard-court play.'},
      {x: 295, y: 155, image: 'rally/1_3.png', feature: 'Durable', details: 'Ndurance rubber outsole is built for increased durability in high wear areas.'} ]},
  { name: "Product 2", img_main: 'rally/2_main.png', image: "rally/2_thumb.png", desc: 'Clementine with NB Navy', link: '',
    dots: [
    {x: 125, y: 180, image: 'rally/2_2.png', feature: 'Incredible Comfort', details: 'Fresh Foam X midsole delivers our most cushioned Fresh Foam experience.'}, 
    {x: 135, y: 70, image: 'rally/2_1.png', feature: 'Intelligently crafted', details: 'Inspired by professional rally cars, this feature-driven style is built for hard-court play.'},
    {x: 295, y: 155, image: 'rally/2_3.png', feature: 'Durable', details: 'Ndurance rubber outsole is built for increased durability in high wear areas.'} ]},
  // { name: "Product 3", img_main: 'rally/3_main.png', image: "rally/3_thumb.png", desc: 'White with Navy', link: '',
  //   dots: [
  //   {x: 125, y: 180, image: 'rally/3_1.png', feature: 'Intelligently crafted', details: 'Inspired by professional rally cars, this feature-driven style is built for hard-court play.'}, 
  //   {x: 135, y: 70, image: 'rally/3_2.png', feature: 'Incredible Comfort', details: 'Fresh Foam X midsole delivers our most cushioned Fresh Foam experience.'},
  //   {x: 295, y: 155, image: 'rally/3_3.png', feature: 'Durable', details: 'Ndurance rubber outsole is built for increased durability in high wear areas.'} ]}
];

const Rally = () => {
  const [active, setActive] = useState(0);
  const [featureNumber, setFeatureNumber] = useState();
  const activeProduct = products[active]
  const navigate = useNavigate();

  const onClickLink =  (link) => {
    const url = products[active].link ? products[active].link : link

    umami?.track('Clicked shop on Rally page', { link: url });
    window.open(url)
  }

  const onPreviousPageClick = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const onNextPageClick = useCallback(() => {
    navigate("/shop-cta");
  }, [navigate]);

  const onClickDot = (id) => {
    if (id == featureNumber) {
      setFeatureNumber(null)
    } else {
      setFeatureNumber(id)
    }    
  }
  
  const renderDots  = () => {
    return(
      (activeProduct.dots || []).map((dot, idx) => (
        ((featureNumber == null) || (featureNumber == idx)) && 
        <div 
          key={`${products[active].name}-dot-${idx}`} 
          style={{ left: `${dot.x}px`, top:  `${featureNumber == null ? dot.y : 190}px` }}
          className={`${styles.redCircle} ${featureNumber == null ? styles.redPulse : '' }`} 
          onClick={() => onClickDot(idx)}>
        </div>    
      ))
    )
  };

  return (
    <div className={styles.shopPage}>
      <NavPanel onClick={onPreviousPageClick} />
      <NavPanel postion='right' onClick={onNextPageClick} />

      <TapArea style={styles.topLeftNav} onClick={onPreviousPageClick} />
      <TapArea style={styles.bottomLeftNav} onClick={onPreviousPageClick} />

      <TapArea style={styles.topRightNav} onClick={onNextPageClick} />
      <TapArea style={styles.bottomRightNav} onClick={onNextPageClick} />

      <ProgressBar current='5' />
      <div className={styles.gradient}></div>

      <div className={styles.headerContainer}>
        <NBLogo />
        <div className={styles.productType}>
          Fresh Foam X CT-Rally
        </div>
        <div className={styles.slogan}> 
          Dominate the court in comfort with a shoe built for tennis athletes.
        </div> 
      </div>

      <div className={styles.productListContainer} >
        <div className={styles.detailArea}>
          <div className={styles.detailWrapper}>
            <img
              src={products[active].img_main}
              alt={products[active].name}
              className={styles.detailImg}
            />

            { featureNumber != null &&   
              <img
                src={activeProduct.dots[featureNumber].image}
                className={`${styles.detailImg} ${styles.featuredImage}`}
                onClick={() => onClickDot(featureNumber)}
              />
            }
            { featureNumber != null &&   
              <div className={`${styles.featureText}`} >
                <div className={styles.featureName}> {activeProduct.dots[featureNumber].feature} </div>
                <div className={styles.featureContent}> {activeProduct.dots[featureNumber].details} </div>
              </div> 
            }

          { renderDots() }
          </div>
        </div>
        <div className={styles.productList}>
          {products.map((product, idx) => (
            <div
              key={product.name}
              className={idx === active ? `${styles.productItem} ${styles.active}` : styles.productItem}
              onClick={() => { setActive(idx) ; setFeatureNumber(null) }}
            >
              <img
                src={product.image}
                alt={product.name}
                className={styles.productThumb}
              />
            </div>
          ))}
        </div>
      </div>
      <div className={styles.productDesc}> 
        {products[active].desc}
      </div>

      <a
        onClick={() => onClickLink('https://www.newbalance.com/tennis-collection/ct-rally/?utm_source=fbig&utm_medium=so&utm_campaign=paid&utm_content=TennisMoMo&utm_term=CTRallyPGP&ecid=so_fbig_paid_TennisMoMo_CTRallyPGP')}  
        className={styles.btnShop}>        
        Shop
      </a>

      <div className={`${styles.text}`}>Designed for superior durability.</div>
      { featureNumber != null &&   
          <div className={styles.overlay} onClick={() => setFeatureNumber(null)}></div>
      }
    </div>
  );
};

export default Rally; 
